import { render } from "./TrabalheConosco.vue?vue&type=template&id=bafeac4e&scoped=true"
import script from "./TrabalheConosco.vue?vue&type=script&lang=js"
export * from "./TrabalheConosco.vue?vue&type=script&lang=js"

import "./TrabalheConosco.vue?vue&type=style&index=0&id=bafeac4e&scoped=true&lang=css"
import "./TrabalheConosco.vue?vue&type=style&index=1&id=bafeac4e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafeac4e"]])

export default __exports__